import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import i18n from "@/locales";
import auth from "./auth";
import alert from "./alert";
import certificate from "./certificate";
import certificateWizard from "./certificateWizard";
import cookies from "./cookies";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /* Modelled as a number to support multiple components */
    loading: 0,
    /* Try to read from the browser settings */
    // locale: navigator.language.substring(0, 2)
    locale: "en"
  },
  getters: {
    isLoading: state => state.loading > 0
  },
  mutations: {
    startLoading(state) {
      state.loading += 1;
    },
    stopLoading(state) {
      state.loading -= 1;
    },
    changeLocale(state, payload) {
      state.locale = payload.locale;

      // Set the locale in $i18n
      // let lang = state.locale;
      let lang = "en";
      // if (lang === "default") {
      //   lang = navigator.language.substring(0, 2);
      // }
      i18n.locale = lang;
    }
  },
  actions: {
    startLoading({ commit }) {
      commit("startLoading");
    },
    stopLoading({ commit }) {
      commit("stopLoading");
    }
  },
  modules: { auth, alert, certificate, certificateWizard, cookies },
  // reducer: add all object other than "loading" , so that "loading" will be refreshed on page load - fix for the issue - loading bar keep on showing when user close the tab and reopen
  plugins: [
    createPersistedState({
      reducer: state => ({
        auth: state.auth,
        alert: state.alert,
        certificate: state.certificate,
        certificateWizard: state.certificateWizard,
        cookies: state.cookies
      }),
      storage: window.localStorage
    })
  ]
});
